const navTrigger = document.querySelector('.navTrigger');
const nav = document.querySelector('.nav');
const socialNav = document.querySelector('.socialNav');
const secondaryNavTriggers = document.querySelectorAll('.secondaryNavTrigger')
const mobileBtnOpen = document.querySelector('.nav-btn__icon--open');
const mobileBtnClose = document.querySelector('.mobile-btn__icon--close');
const siteHeader = document.querySelector('.site-header');
const body = document.querySelector('body');

if (navTrigger) {

    navTrigger.addEventListener('click', () => {
        // change aria-expanded on click
        let ariaExpanded = navTrigger.getAttribute('aria-expanded');

        if (ariaExpanded === "true") {
            ariaExpanded = "false"
        } else {
            ariaExpanded = "true"
        }

        navTrigger.setAttribute('aria-expanded', ariaExpanded);

        navTrigger.classList.toggle('is-active');
        nav.classList.toggle('is-active');
        // socialNav.classList.toggle('hidden');
        mobileBtnOpen.classList.toggle('hidden')
        mobileBtnClose.classList.toggle('hidden')
        siteHeader.classList.toggle('active')
        body.classList.toggle('no-scroll')
    })

    secondaryNavTriggers.forEach( (item) => {
        item.addEventListener('click', () => {
            // change aria-expanded on click
            let ariaExpanded = item.getAttribute('aria-expanded');

            if (ariaExpanded === "true") {
                ariaExpanded = "false"
            } else {
                ariaExpanded = "true"
            }

            let secondaryNav = item.parentElement.querySelector('.secondaryNav');

            item.classList.toggle('is-active');
            item.setAttribute('aria-expanded', ariaExpanded);
            secondaryNav.classList.toggle('is-active');
        })
    })
}